import { Component,  Input, EventEmitter, Output } from '@angular/core';
import { HEIGHTS } from '../../../../src/app/helpers/helpers';
import { CommonModule } from '@angular/common';
import { MatButtonModule } from '@angular/material/button';

@Component({
    selector: 'inverse-button',
    template: `
<button mat-button [color]="warn ? 'warn' : 'primary'" [disabled]="disabled" [ngStyle]="{height: height}" (click)="clickButton($event)"><ng-content></ng-content></button>
`,
    styles: [`
  .mat-button.mat-primary { color: #11b8c1; background: white; }
`],
    standalone: true,
    imports: [CommonModule, MatButtonModule],
})

export class InverseButtonComponent {
  @Input() height = HEIGHTS.thirty
  @Input() disabled = false
  @Input() warn = false
  @Output() click: EventEmitter<void> = new EventEmitter();

  clickButton(event) {
    event.stopPropagation()
    this.click.emit()
  }

}

